import { render, staticRenderFns } from "./FormChapterEdit.vue?vue&type=template&id=1de2a3cd&"
import script from "./FormChapterEdit.vue?vue&type=script&lang=js&"
export * from "./FormChapterEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports